import rootApi from '@utils/baseAPI/WrapperApi';

export const apiGetSimCards = (params) => rootApi.get('api/sim-cards', { params });
export const apiExportSimCards = (params) =>
  rootApi.get('api/sim-cards/export', { params, responseType: 'blob' });
export const apiGetSimCardById = (id) => rootApi.get(`api/sim-cards/${id}`);
export const apiCreateSimCard = (data) => rootApi.post('api/sim-cards', data);
export const apiUpdateSimCard = (id, data) => rootApi.put(`api/sim-cards/${id}`, data);
export const apiUpdateSimCardStatus = (id, data) => rootApi.put(`api/sim-cards/${id}/status`, data);
export const apiAssignSimDevice = (id, data) =>
  rootApi.post(`api/sim-cards/${id}/assign-device`, data);
export const apiUnassignSimDevice = (id, data) =>
  rootApi.post(`api/sim-cards/${id}/unassign-device`, data);
export const apiGetSimAssignmentHistory = (id) =>
  rootApi.get(`api/sim-cards/${id}/assignment-history`);
export const apiDeleteSimCard = (id) => rootApi.delete(`api/sim-cards/${id}`);
